import type { RegisteredServices } from '@/core/container/types'
import type {
  ImportMatchingCountrySharedData,
  ImportMatchingSharedData,
  ImportProgressSharedData,
  ImportUploadSharedData,
} from '@/components/shared/import/upload/types'
import type { LookupFlowPreview } from '@/services/domain/lookup/types'
import type { ImportSessionPreviewMappingItem } from '@/data/repositories/domain/import/types'

export const EmailLookupHistoryTableId = 'emailLookupHistoryTable' as RegisteredServices

export const emailLookupFlowStepVariant = ['upload', 'matching', 'preview', 'progress'] as const
export type EmailLookupFlowStep = (typeof emailLookupFlowStepVariant)[number]

export type EmailLookupFlowSharedData = ImportUploadSharedData<LookupFlowPreview> &
  ImportMatchingSharedData &
  ImportMatchingCountrySharedData &
  ImportProgressSharedData

export type EmailLookupImportProcess = {
  mapping: ImportSessionPreviewMappingItem[]
  country?: string
  excludeFirstRow?: boolean
}

export const EmailLookupBulkTableId = 'emailLookupBulkTable' as RegisteredServices

export type EmailLookupBulkProgressResponse = {
  items: EmailLookupBulkProgress[]
}

export type EmailLookupBulkProgress = {
  entityId: number
  percentageValue: number
}
